export class CreatePermissionDto {
  name: string;
  description: string;
  rolesIds: number;
}
